import React from 'react';
import { observer } from 'mobx-react';
import './ChatMessageCounter.scss';

const ChatMessageCounter = observer(({ unread, themeMode }) => {
  const getContainerClasses = mode => {
    switch (mode) {
      case 'classic':
        return 'message-counter-wrp message-counter-wrp-theme-classic';
      case 'dark':
        return 'dark-theme message-counter-wrp message-counter-wrp-theme-dark';
      case 'light':
        return 'message-counter-wrp message-counter-wrp-theme-light';
      default:
        return 'message-counter-wrp';
    }
  };
  if (!unread) {
    return null;
  }

  return (
    <div className={getContainerClasses(themeMode)}>
      <span className="message-counter-caption">{unread}</span>
    </div>
  );
});

export default ChatMessageCounter;
